import React from "react"
import * as Yup from "yup"
import { Col, Row, CardTitle, Label, Input } from "reactstrap"

import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { Link, useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import {
  checkExtension,
  getBusinsessAddress,
  showRegistrationType,
} from "helpers/common"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"

const NonIndividualView = ({ partnerData }) => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()
  //meta title
  document.title = "Investor Details  | Prachay"

  const onFormSubmit = async (values) => {
    try {
      const response = await mutate(values).unwrap()
      if (response.success) {
        navigate("/investor")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        horizontalformik.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  const businessFiles = [
    { key: "initial_partnership_deed", label: "Initial Partnership Deed" },
    { key: "latest_partnership_deed", label: "Latest Partnership Deed" },
    {
      key: "certificate_of_incorporation",
      label: "Certificate of Incorporation",
    },
    { key: "gstin_certificate", label: "GSTIN Certificate" },
    { key: "memorandum_of_association", label: "Memorandum of Association" },
    { key: "articles_of_association", label: "Articles of Association" },
    { key: "initial_llp_deed", label: "Initial LLP Deed" },
    { key: "latest_llp_deed", label: "Latest LLP Deed" },
    { key: "huf_creation_document", label: "HUF Creation Document" },
    { key: "trust_deed", label: "Trust Deed" },
    { key: "society_bye_laws", label: "Society Bye-laws" },
  ]
  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <Row className="mb-2">
            <Col xl={6}>
              <Label className="col-form-label">Name of the Entity</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={partnerData?.investorCompanyDetails?.entity_name}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Date of Incorporation</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.date_of_incorporation
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Constitution of Business</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.constitution_of_business
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Address</Label>
              <Input
                disabled
                name="name"
                type="textarea"
                className="form-control"
                value={getBusinsessAddress(partnerData?.investorCompanyDetails)}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">PAN</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={partnerData?.pan_no}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">GSTIN</Label>
              <Input
                disabled
                name="name"
                type="text"
                className="form-control"
                value={
                  partnerData?.investorCompanyDetails?.gstin || "Not Applicable"
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Phone No.</Label>
              <Input
                disabled
                name="phone"
                type="text"
                className="form-control"
                value={partnerData?.phone}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Email Address</Label>
              <Input
                disabled
                name="email"
                type="text"
                className="form-control"
                value={partnerData?.email}
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">Political Exposure</Label>
              <Input
                disabled
                name="email"
                type="text"
                className="form-control"
                value={
                  partnerData?.businessAdditionalDetails?.politicalExposure
                }
              />
            </Col>
            <Col xl={6}>
              <Label className="col-form-label">
                Entity Registration No.(
                {showRegistrationType(
                  partnerData?.businessAdditionalDetails
                    ?.constitution_of_business
                )}
                )
              </Label>
              <Input
                disabled
                name="email"
                type="text"
                className="form-control"
                value={
                  partnerData?.businessAdditionalDetails?.entity_registration_no
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <div>
            <div>
              <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                <CardTitle className="">Bank Details</CardTitle>
              </div>
              <Row className="mb-2">
                <Col xl={6}>
                  <Label className="col-form-label">Account Holders Name</Label>
                  <Input
                    disabled
                    name="account_holder"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_holder}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Account Number</Label>
                  <Input
                    disabled
                    name="account_no"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_no}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Bank Name</Label>
                  <Input
                    disabled
                    name="bank_name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.bank_name}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">IFSC</Label>
                  <Input
                    disabled
                    name="ifsc"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.ifsc}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Account Type</Label>
                  <Input
                    disabled
                    name="ifsc"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsBankDetails?.account_type}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      {partnerData?.investorsDematDetails && (
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                  <CardTitle className="">Demat Details</CardTitle>
                </div>
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Demat Account Number
                    </Label>
                    <Input
                      disabled
                      name="demat_account_no"
                      type="text"
                      className="form-control"
                      value={
                        partnerData?.investorsDematDetails?.demat_account_no
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Depository Participant Name
                    </Label>
                    <Input
                      disabled
                      name="depository_participant_name"
                      type="text"
                      className="form-control"
                      value={
                        partnerData?.investorsDematDetails
                          ?.depository_participant_name
                      }
                    />
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">Depository Name</Label>
                    <Input
                      disabled
                      name="exchange_type"
                      type="text"
                      className="form-control"
                      value={partnerData?.investorsDematDetails?.exchange_type}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Row>
        <Col xl={12}>
          <div>
            <div>
              <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                <CardTitle className="">Authorised Person Details</CardTitle>
              </div>
              <Row className="mb-2">
                <Col xl={6}>
                  <Label className="col-form-label">Name</Label>
                  <Input
                    disabled
                    name="demat_account_no"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.name}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Date of Birth</Label>
                  <Input
                    disabled
                    name="depository_participant_name"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.dob}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">PAN</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsPAN?.pan}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Aadhaar No.</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={partnerData?.investorsAadhaar?.aadhaar_no}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">Designation</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={partnerData?.businessAdditionalDetails?.designation}
                  />
                </Col>
                <Col xl={6}>
                  <Label className="col-form-label">DIN</Label>
                  <Input
                    disabled
                    name="exchange_type"
                    type="text"
                    className="form-control"
                    value={
                      partnerData?.businessAdditionalDetails?.dpin ??
                      "Not Applicable"
                    }
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <CardTitle className="mt-4 mb-4">Documents</CardTitle>

          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Entity Documents
          </CardTitle>
          <div className="documents-section">
            {businessFiles.map((item, index) => (
              <React.Fragment key={`businessFiles_${index}`}>
                {partnerData?.businessAdditionalDetails?.[item.key] && (
                  <div className="documents-box">
                    <div className="file-type">
                      {checkExtension(
                        partnerData?.businessAdditionalDetails?.[item.key]
                      ) === "pdf" ? (
                        <img src={pdfIcon} alt="" />
                      ) : (
                        <img src={imageIcon} alt="" />
                      )}

                      <div>
                        <p>{item.label}</p>
                        <Link
                          to={
                            partnerData?.businessAdditionalDetails?.[
                              `${item.key}_url`
                            ]
                          }
                          target="_blank"
                        >
                          <span className="text-small text-success cursor-pointer">
                            View
                          </span>
                        </Link>
                      </div>
                    </div>
                    {/* <div className="verified-user">
                          <img src={check} alt="" /> Verified
                        </div> */}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <hr className="my-4" />
          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Authorised Person Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorsAadhaar?.aadhaar_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsAadhaar.aadhaar_file_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Aadhaar</p>
                    <Link
                      to={partnerData?.investorsAadhaar.aadhaar_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
            {partnerData?.avatar_url && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.avatar_url) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Selfie</p>
                    <Link to={partnerData?.avatar_url} target="_blank">
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
            {partnerData?.investorsPAN?.pan_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(partnerData?.investorsPAN?.pan_file_url) ===
                  "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>PAN</p>
                    <Link
                      to={partnerData?.investorsPAN?.pan_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}

            {partnerData?.businessAdditionalDetails?.authority_letter && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.businessAdditionalDetails?.authority_letter_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Authority Letter</p>
                    <Link
                      to={
                        partnerData?.businessAdditionalDetails
                          ?.authority_letter_url
                      }
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
          </div>

          <hr className="my-4" />
          <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
            Banking Documents
          </CardTitle>
          <div className="documents-section">
            {partnerData?.investorsDematDetails?.cml_report && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsDematDetails?.cml_report_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>CML Report</p>
                    <Link
                      to={partnerData?.investorsDematDetails.cml_report_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
            {partnerData?.investorsBankDetails?.cheque_file && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    partnerData?.investorsBankDetails.cheque_file_url
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>Cheque</p>
                    <Link
                      to={partnerData?.investorsBankDetails.cheque_file_url}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
                {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default NonIndividualView
